import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { AssurancePanel, WorkspacesPanel, DocPortalPanel, AiAssistantPanel } from "@/components/suite/SuitePanels";
import { SharePackagesPanel } from "@/components/suite/SharePackagesPanel";
import { SecurityGateEvidence } from "@/components/suite/SecurityGateEvidence";

const TABS = [["assurance", "Assurance Center"], ["workspaces", "Due Diligence Rooms"],
              ["docs", "Document Portal"], ["ai", "AI Questionnaire Assistant"],
              ["share", "Share Security Packages"]];

export default function SecuritySuite() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("assurance");
  useEffect(() => { if (user && !user.super_admin) navigate("/admin"); }, [user, navigate]);
  return (
    <div className="min-h-screen bg-slate-50" data-testid="security-suite">
      <header className="bg-navy text-white">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <Link to="/compliance" className="text-white/50 text-xs flex items-center gap-1 hover:text-white" data-testid="ss-back"><ArrowLeft className="w-3.5 h-3.5" /> Compliance Command Center</Link>
          <div className="flex flex-wrap items-end justify-between gap-3 mt-2">
            <div>
              <h1 className="font-heading text-2xl font-extrabold tracking-tight flex items-center gap-2"><ShieldCheck className="w-6 h-6 text-cobalt" /> ENTERPRISE SECURITY SUITE</h1>
              <p className="text-white/60 text-xs mt-1 max-w-3xl">Customer-facing security review platform — Due Diligence Rooms, document portal, assurance registry and AI-assisted questionnaires. Everything grounded in live, honest evidence.</p>
            </div>
            <Link to="/enterprise-readiness" className="px-4 py-2 rounded-full bg-white/10 text-white text-xs font-bold hover:bg-white/20" data-testid="ss-readiness-link">Enterprise Readiness Center</Link>
          </div>
        </div>
      </header>
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex gap-1.5 flex-wrap mb-4">
          {TABS.map(([k, label]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`ss-tab-${k}`}
              className={`px-4 py-2 rounded-full text-xs font-bold transition-colors ${tab === k ? "bg-navy text-white" : "bg-white text-slate-500 border border-slate-200 hover:border-cobalt"}`}>{label}</button>
          ))}
        </div>
        {tab === "assurance" && <div className="space-y-4"><SecurityGateEvidence /><AssurancePanel /></div>}
        {tab === "workspaces" && <div className="space-y-4"><SecurityGateEvidence compact /><WorkspacesPanel /></div>}
        {tab === "docs" && <DocPortalPanel />}
        {tab === "ai" && <AiAssistantPanel />}
        {tab === "share" && <SharePackagesPanel />}
      </div>
    </div>
  );
}
